import { render } from "./BusinessList.vue?vue&type=template&id=29129557&scoped=true"
import script from "./BusinessList.vue?vue&type=script&lang=js"
export * from "./BusinessList.vue?vue&type=script&lang=js"

import "./BusinessList.vue?vue&type=style&index=0&id=29129557&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29129557"]])

export default __exports__